import { useMainStore } from "@/store";
import useVuelidate from "@vuelidate/core";
import { mapState } from "pinia";
import { defineComponent } from "vue";
import { EventBusNames } from "@/utils/EventBus";

export default defineComponent({
  mounted() {
    this.form.gender = this.session?.gender || "";
    this.form.accepted_gender = this.session?.accepted_gender ?? "all";
  },
  data() {
    return {
      options: [
        { id: "female", title: "Feminino" },
        { id: "male", title: "Masculino" },
        { id: "other", title: "Outro" },
      ],
      acceptedGenderOptions: [
        { id: "all", title: "Todos os gêneros" },
        { id: "female", title: "Feminino" },
        { id: "male", title: "Masculino" },
      ],
      form: {
        gender: "",
        accepted_gender: "all" as string,
      },
      v$: useVuelidate(),
      submitting: false,
    };
  },
  computed: {
    ...mapState(useMainStore, ["session"]),
  },
  validations: {
    form: {
      gender: {},
      accepted_gender: {},
    },
  },
  methods: {
    async submit() {
      try {
        this.submitting = true;
        await this.$userService.update(this.form);
        this.$eventBus.$emit(EventBusNames.SHOW_TOAST, {
          title: "Alterações feitas",
          msg: "Suas informações foram salvas",
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.submitting = false;
      }
    },
  },
});
